import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

interface IStylesProps {
  isPreview?: boolean;
}

const fontFamily = "Helvetica-Bold, Helvetica";

export default makeStyles<MuiTheme, IStylesProps>(() => ({
  barn: {},
  hasHorses: {
    cursor: ({ isPreview }) => (isPreview ? "default" : "pointer"),
    "& $barnPath": {
      fill: "#6bc285"
    },
    "& $circle": {
      fill: "#f3f5ea",
      stroke: "#009444",
      strokeWidth: 2,
      strokeMiterlimit: 10
    }
  },
  circle: { fill: "#E6E6E5" },
  barnPath: {
    fill: "#d7d9d1"
  },
  // cls2: {
  //   clipPath: "url(#clippath)"
  // },
  st0: { fill: "#2b2b2b" },
  st1: {
    fill: "#2b2b2b",
    fontFamily,
    fontWeight: 700,
    isolation: "isolate",
    fontSize: 15
  },
  st2: { stroke: "#757575", fill: "#fff", strokeWidth: "1.6px" },
  st3: {
    fill: "#fff",
    fontFamily,
    fontWeight: 700,
    isolation: "isolate",
    fontSize: "9.5px",
    letterSpacing: "0em"
  },
  st5: {
    fontSize: 13,
    letterSpacing: "0em",
    fontFamily,
    fontWeight: 700,
    isolation: "isolate",
    fill: "#5c574a"
  },
  st6: {
    fill: "#272727",
    fontFamily,
    fontWeight: 700,
    isolation: "isolate",
    fontSize: "8.5px",
    letterSpacing: "0em"
  },
  st7: {
    fill: "#272727",
    fontFamily,
    fontWeight: 700,
    isolation: "isolate",
    fontSize: "8.5px",
    letterSpacing: "0em"
  },
  st8: {
    fontSize: "8px",
    letterSpacing: "0em",
    fontFamily,
    fontWeight: 700,
    isolation: "isolate",
    fill: "#4a463c"
  },
  st9: {
    fill: "#8a5a52",
    letterSpacing: "0em",
    fontFamily,
    fontWeight: 700,
    isolation: "isolate",
    fontSize: "9.5px"
  },
  st10: {
    fill: "#5c574a",
    fontFamily,
    fontWeight: 700,
    isolation: "isolate",
    fontSize: "10px",
    letterSpacing: ".1em"
  },
  st11: {
    fill: "#8a6a3c",
    fontFamily,
    fontWeight: 700,
    isolation: "isolate",
    fontSize: "9.5px",
    letterSpacing: "0em"
  },
  st14: {
    fill: "#c0392b",
    fontFamily,
    fontWeight: 700,
    isolation: "isolate",
    fontSize: "9.5px",
    letterSpacing: "0em"
  },
  st15: {
    fontSize: "8px",
    letterSpacing: "0em",
    fontFamily,
    fontWeight: 700,
    isolation: "isolate",
    fill: "#6b6455"
  },
  st16: {
    fill: "#4a463c",
    fontFamily,
    fontWeight: 700,
    isolation: "isolate",
    fontSize: "9.5px",
    letterSpacing: "0em"
  },
  st17: {
    fill: "#4a463c",
    fontFamily,
    fontWeight: 700,
    isolation: "isolate",
    fontSize: "8.5px",
    letterSpacing: "0em"
  },
  st18: {
    fill: "#4a463c",
    fontFamily,
    fontWeight: 700,
    isolation: "isolate",
    fontSize: "8.5px",
    letterSpacing: "0em"
  },
  st19: { stroke: "#e9e4d6", strokeWidth: "30px", fill: "none" },
  st20: { fill: "none", strokeWidth: "20px", stroke: "#fff" },
  st21: {
    fill: "none",
    stroke: "#e4decb",
    strokeWidth: "9px",
    strokeLinejoin: "round"
  },
  st22: {
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: "6px"
  },
  st23: { fill: "#c0392b" },
  st24: { fill: "#eae7de", stroke: "#d6d2c6" },
  st25: { fill: "#757575" },
  st27: { fill: "#fbf5e7" },
  st28: { fill: "#dbedc8" },
  st29: { fill: "#4a4a4a" },
  st30: { fill: "#d3c7ad" },
  st31: { fill: "#ddebcc" },
  st32: { fill: "#bedfa9" },
  st33: { fill: "#efdcbe", stroke: "#d8be94" },
  st35: { fill: "#ebd6b5" },
  st36: { fill: "#96d3f0" }
}));
